import { ORDER_REQUEST_MESSAGES, OrderRequestMessages } from "./order-request-messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";

export type OrderCommentsTabMessages = ActionButtonMessages &
  OrderRequestMessages & {
    orderCommentTitle: string;
    orderCom1Label: string;
    orderComments2Label: string;
    orderComments3Label: string;
  };

export const ORDER_COMMENTS_TAB_MESSAGES: OrderCommentsTabMessages = {
  orderCommentTitle: "Comentários do Pedido",
  orderCom1Label: "Comentário 1",
  orderComments2Label: "Comentário 2",
  orderComments3Label: "Comentário 3",

  ...ORDER_REQUEST_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
};
